export function Lerp(a: number, b: number, t: number) {
    return a + (b - a) * t;
}
